// config/apiConfig.js
// CHANGE ENVIRONMENT HERE - Just change this one line!
const ENVIRONMENT = 'train'; // 'local', 'train', or 'prod'

/**
 * Per-environment flags.
 * blockDevTools — soft client guard (shortcuts + open detection + modal).
 * Toggle true/false per env without code changes elsewhere.
 * Note: this is not Chrome Enterprise policy; determined users can still bypass.
 */
const API_ENDPOINTS = {
  local: {
    baseURL: 'http://localhost:50623/',
    name: 'Local Development',
    blockDevTools: false,
  },
  train: {
    baseURL: "https://ascensionqapi.azurewebsites.net/aqtrainapi/",
    name: "Test Environment",
    blockDevTools: false,
  },
  prod: {
    baseURL: "https://ascensionqapi.azurewebsites.net/newuiaqtrailsapi/",
    name: "Production Environment",
    blockDevTools: true,
  },
  extra: {
    baseURL: "https://ascensionqapi.azurewebsites.net/aqtraincopyapi/",
    name: "extra Environment",
    blockDevTools: false,
  },
};

// Get current environment config
const getCurrentConfig = () => {
  return API_ENDPOINTS[ENVIRONMENT] || API_ENDPOINTS.local;
};

// API Configuration
export const API_CONFIG = {
  ...getCurrentConfig(),
  blobBaseURL: "https://ascensionblob.blob.core.windows.net/",
  endpoints: {
    login: "/api/UserLogin/User_Login_new",
    loginMfa: "/api/UserLoginMfa/User_Login_MFA",
    loginMfaVerify: "/api/UserLoginMfa/User_Login_MFA_Verify",
    loginMfaResendOtp: "/api/UserLoginMfa/User_Login_MFA_ResendOtp",
    loginMfaSwitchMethod: "/api/UserLoginMfa/User_Login_MFA_SwitchMethod",
    loginMfaOrgEntryChallenge: "/api/UserLoginMfa/User_Login_MFA_OrgEntryChallenge",
    getMfaSettings: "/api/UserLoginMfa/GetMfaSettings",
    setupAuthenticator: "/api/UserLoginMfa/SetupAuthenticator",
    confirmAuthenticatorSetup: "/api/UserLoginMfa/ConfirmAuthenticatorSetup",
    setPreferredMfaMethod: "/api/UserLoginMfa/SetPreferredMfaMethod",
    resetAuthenticator: "/api/UserLoginMfa/ResetAuthenticator",
    validateSession: "/api/UserLogin/ValidateSession",
    logout: "/api/UserLogin/User_Logout",
    checkEmailId: "/api/UserLogin/CheckEmailId",
    validateOTP: "/api/UserLogin/ValidateOTP",
    setNewPassword: "/api/UserLogin/SetNewPassword",
  },

  // Request configuration
  timeout: 60000, // default API calls (60 seconds)
  // Large JSON/base64 uploads (FAQ user guides, vault docs) need longer than 60s
  uploadTimeout: 10 * 60 * 1000, // 10 minutes
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

// Helper function to get full URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.baseURL}${API_CONFIG.endpoints[endpoint]}`;
};

// Environment info for debugging
export const getEnvironmentInfo = () => {
  return {
    current: ENVIRONMENT,
    config: getCurrentConfig(),
    availableEnvironments: Object.keys(API_ENDPOINTS),
  };
};

/**
 * True when this environment should block / warn on DevTools use.
 * Always off on localhost / 127.0.0.1 so local debugging is never blocked,
 * even if ENVIRONMENT is set to prod/train while the React app runs on :3000.
 */
export const isDevToolsBlocked = () => {
  if (typeof window !== "undefined") {
    const host = String(window.location?.hostname || "").toLowerCase();
    if (
      host === "localhost" ||
      host === "127.0.0.1" ||
      host === "[::1]" ||
      host.endsWith(".local")
    ) {
      return false;
    }
  }
  return Boolean(getCurrentConfig()?.blockDevTools);
};

export default API_CONFIG;
